import { useLocalStream } from '@/composables'
import { torch } from '@/messages'
import { useUserStore } from '@/stores'
import {mediator, messenger} from '@communication'

export default class TorchProcedure {
  constructor () {
    this.name = 'torchProcedure'
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:data', this.handler)
  }
  
  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handler = async (event, channel) => {
    if (channel === 'strategy:data') {
      const user = useUserStore()
      const { type } = event
      if (user.isClient) {
        if (type === 'torch:toggle') {
          const stream = useLocalStream()
          await stream.toggleTorch()
        }
      }
    }
   }

  toggle = () => {
    mediator.broadcast(torch.toggle())
  }
}
